import { SET_VALIDATION_ERRORS, REMOVE_VALIDATION_ERROR, CLEAR_VALIDATION_ERRORS } from "./constants"

export const VALIDATION_INITIAL_STATE = { errors: [] }

function validationReducer(state = VALIDATION_INITIAL_STATE, action: any) {
  switch (action.type) {
    case SET_VALIDATION_ERRORS: return {...state, errors: [...action.value]}
    case REMOVE_VALIDATION_ERROR: return {...state, errors: state.errors.filter(error => error !== action.id)}
    case CLEAR_VALIDATION_ERRORS: return {...VALIDATION_INITIAL_STATE}
    default: return state
  }
}

export default validationReducer